import { ApolloError } from '@apollo/client'
import { ImportResponse, Maybe } from '../../../../generated/graphql'
import { useTranslation } from 'react-i18next'
import {
  DisableIcon,
  ProgressDoneIcon,
  WarningIcon,
} from '@sitoo/mui-components'
import { StatusDisplay } from './status-display'

interface ImportStatusDisplayProps {
  importError?: ApolloError | undefined
  importData?: Maybe<ImportResponse> | undefined
}

export const ImportStatus = ({
  importError,
  importData,
}: ImportStatusDisplayProps) => {
  const { t } = useTranslation(['settings'])

  const successfulCount =
    (importData?.imported || 0) + (importData?.updated || 0)
  const hasFailures = (importData?.failed || 0) > 0
  const isCompleteSuccess = !importError && successfulCount > 0 && !hasFailures
  const isPartialSuccess = !importError && successfulCount > 0 && hasFailures

  if (isCompleteSuccess) {
    return (
      <StatusDisplay
        icon={
          <ProgressDoneIcon
            fontSize="large"
            color="success"
            data-testid="success-icon"
          />
        }
        message={t('settings:import_data.finished')}
      />
    )
  }

  if (isPartialSuccess) {
    return (
      <StatusDisplay
        icon={
          <WarningIcon
            fontSize="large"
            color="warning"
            data-testid="partial-success-icon"
          />
        }
        message={t('settings:import_data.partially_imported')}
      />
    )
  }

  return (
    <StatusDisplay
      icon={
        <DisableIcon fontSize="large" color="error" data-testid="error-icon" />
      }
      message={t('settings:import_data.failed')}
    />
  )
}
